import GlobalStyles from '@mui/material/GlobalStyles';
import { Outlet } from 'react-router';
import { BrandingSidebar } from 'shared/components/common/BrandingSidebar/index.js';

import { Wrapper } from './AuthLayout.styled.js';

export const AuthLayout = () => {
  return (
    <Wrapper>
      <GlobalStyles
        styles={{
          '& html body': {
            overflowY: 'scroll',
          },
        }}
      />
      <BrandingSidebar />
      <Outlet />
    </Wrapper>
  );
};
